import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  doc,
} from "firebase/firestore";
import { firestore } from "../../../../components/firebase/FirebaseConfig";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  favFriendCaddie,
  favFriend,
} from "../../../../components/friend/FavFriend";
import CaddieCard from "./component/CaddieCard";
import ModalCaddieDetail from "./component/ModalCaddieDetail";
import ModalFilter from "./component/ModalFilter";
import CaddieSearch from "./component/CaddieSearch";
import StackFilter from "./component/StackFilter";
import Label from "../../../createlabel/Label";
import { ChatTo } from "../../../../components/chat/Chat";
import Load from "../../../../components/Load";
import algoliasearch from "algoliasearch/lite";

function CourseDetailCaddieBody({ courseData, setCourseData }) {
  const [caddieList, setCaddieList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [caddieData, setCaddieData] = useState({});
  const [favoriteFriendsList, setFavoriteFriendsList] = useState({});
  const [caddieProfile, setCaddieProfile] = useState({});
  const [userLabels, setUserLabels] = useState([]);
  const [selectedUserLabel, setSelectedUserLabel] = useState(null);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [triggerFriendList, setTriggerFriendList] = useState(true);
  const [triggerGetLabel, setTriggerGetLabel] = useState(false);
  const [originalCaddieList, setOriginalCaddieList] = useState([]);
  const [openSearch, setOpenSearch] = useState(false);
  const [favoriteFriends, setFavoriteFriends] = useState(false);
  const [caddieId, setCaddieId] = useState([]);
  const [favFriendsId, setFavFriendsId] = useState([]);
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const userData = useSelector((state) => state.user.data);
  const navigate = useNavigate();

  const [sortData, setSortData] = useState({
    isLabel: { state: false, selectedLabels: [] },
    isFavorites: { state: false },
    isStar: { state: false },
    isPro: { state: false },
    age: { state: false, min: 18, max: 40 },
    isBlocks: { state: false },
  });

  const [tempSortData, setTempSortData] = useState({
    isLabel: { state: true, selectedLabels: [] },
    isFavorites: { state: true },
    isStar: { state: true },
    isPro: { state: true },
    age: { state: true, min: 18, max: 40 },
    isBlocks: { state: true },
  });

  const [search, setSearch] = useState({
    province: {
      state: false,
      value: "",
    },
    text: {
      state: false,
      value: "",
    },
    nearMe: {
      state: false,
    },
  });

  const trueStates = Object.keys(sortData).filter(
    (key) => sortData[key].state === true
  );

  const [page, setPage] = useState(0); // ใช้ page สำหรับ pagination
  const [hasMore, setHasMore] = useState(true); // เช็คว่าโหลดข้อมูลครบหรือยัง
  const [error, setError] = useState(null);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    async function fetchData() {
      if (!userData?.uid || !courseData?.courseId) return;

      const q = query(
        collection(firestore, "labels"),
        where("userId", "==", userData.uid)
      );
      const querySnapshot = await getDocs(q);
      let dataArray = [];
      querySnapshot.forEach((doc2) => {
        dataArray.push({ docId: doc2.id, ...doc2.data() });
      });
      setUserLabels(dataArray);

      let caddieAssignments = [];
      const queryCaddieInCourse = query(
        collection(firestore, "caddieRequests"),
        where("courseId", "==", courseData.courseId)
      );
      const queryCaddieSnapshot = await getDocs(queryCaddieInCourse);
      queryCaddieSnapshot.forEach((doc) => {
        if (doc.data().status !== "removed") {
          caddieAssignments.push(doc.data().caddieId);
        }
      });
      setCaddieId(caddieAssignments);

      const queryFavFriends = query(
        collection(firestore, "favoriteFriends"),
        where("userId", "==", userData.uid),
        where("status", "==", "active")
      );
      const querySnapshotFavFriends = await getDocs(queryFavFriends);
      let dataArrayFavFriend = [];
      querySnapshotFavFriends.forEach((doc2) => {
        dataArrayFavFriend.push(doc2.data().caddieId);
      });
      setFavFriendsId(dataArrayFavFriend);
    }

    fetchData();
  }, [userData, triggerGetLabel]);

  useEffect(() => {
    const searchClient = algoliasearch(
      "RJJNPL7MRL",
      "bb21db75be816cbedc8dd1b5838e4bba"
    );
    const usersIndex = searchClient.initIndex("users");
    const caddieProfilesIndex = searchClient.initIndex("caddieProfiles");
    const courseIndex = searchClient.initIndex("courses");
    const caddieRequestsIndex = searchClient.initIndex("caddieRequests");
    const labeledUsersIndex = searchClient.initIndex("labeledUsers");

    const getCurrentLocation = () => {
      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => resolve(position.coords),
            (error) => reject(error)
          );
        } else {
          reject(new Error("Geolocation not supported"));
        }
      });
    };

    const fetchCaddies = async () => {
      setLoading(true);
      try {
        const querySearch = search.text.state ? search.text.value : "";
        const queryProvince = search.province.state
          ? search.province.value
          : "";
        const queryNearMe = search.nearMe.state;
        const querySort = sortData;
        let filters = [];
        // console.log(querySort)
        let testFirstName =
          "Por, Crystal, Felecia, Genesis, Isobel, Jane, Judy_, June, Nicole, Pus, Nicole, Sonia";
        let firstNamesArray = testFirstName
          .split(", ")
          .map((name) => `[ทดสอบระบบ]${name}`);

        const caddieIdsFilter = caddieId
          .map((caddie) => `uid:"${caddie}"`) // ต้องใส่เครื่องหมายคำพูดรอบค่า
          .join(" OR ");

        filters = [
          "role:caddie",
          `${caddieIdsFilter}`,
          `NOT firstName:${firstNamesArray.join(" AND NOT firstName:")}`,
        ];

        // console.log(filters);

        let courseIdsFilter = "";
        let caddieUidsFilter = "";
        let nearMeFilter = "";

        if (querySort.isStar.state) {
          filters.push("isStar:true");
        }

        if (querySort.isPro.state) {
          filters.push("isPro:true");
        }

        if (
          querySort.isLabel.state &&
          querySort.isLabel.selectedLabels.length > 0
        ) {
          const labelIdsFilter = querySort.isLabel.selectedLabels
            .map((label) => `labels:"${label.id}"`) // ต้องใส่เครื่องหมายคำพูดรอบค่า
            .join(" OR "); // ใช้ OR เพื่อให้ Algolia ค้นหาค่าที่ตรงกับ array ใด ๆ

          const labeledUsersQuery = await labeledUsersIndex.search("", {
            filters: labelIdsFilter, // ใช้ filters เพื่อค้นหา
          });

          const caddieIds = labeledUsersQuery.hits.map(
            (caddie) => caddie.friendId
          );
          const caddieIdsFilter = caddieIds
            .map((id) => `uid:"${id}"`) // ต้องใส่เครื่องหมายคำพูดรอบค่า
            .join(" OR ");

          filters.push(`(${caddieIdsFilter})`);
        }

        if (querySort.isFavorites.state && favFriendsId.length > 0) {
          const favFriendsFilter = favFriendsId
            .map((id) => `uid:"${id}"`) // ต้องใส่เครื่องหมายคำพูดรอบค่า
            .join(" OR ");

          filters.push(`(${favFriendsFilter})`);
        }

        if (querySort.age.state) {
          const minAgeYear = currentYear - sortData.age.max;
          const maxAgeYear = currentYear - sortData.age.min;

          // สร้าง array ของปีที่ต้องการ
          const yearsToFilter = [];
          for (let year = minAgeYear; year <= maxAgeYear; year++) {
            yearsToFilter.push(`birthDate.year:${year}`);
          }

          yearsToFilter.sort((a, b) => {
            const yearA = parseInt(a.split(":")[1]);
            const yearB = parseInt(b.split(":")[1]);
            return yearB - yearA; // เรียงจากมากไปน้อย
          });

          // รวม filter เป็น OR
          const yearFilter = yearsToFilter.join(" OR ");

          // เพิ่ม filter ใน query
          filters.push(yearFilter);
        }
        // ค้นหาตำแหน่งของผู้ใช้ ถ้าต้องการค้นหาใกล้เคียง
        if (queryNearMe) {
          const location = await getCurrentLocation();
          const { latitude, longitude } = location;
          // ค้นหาคอร์สที่ใกล้เคียงที่สุด
          const courseQuery = await courseIndex.search("", {
            aroundLatLng: `${latitude},${longitude}`,
            aroundRadius: 10000, // กำหนดระยะห่าง (เช่น 10 กิโลเมตร)
          });
          const courseIds = courseQuery.hits.map((course) => course.id);

          if (courseIds.length > 0) {
            courseIdsFilter = courseIds
              .map((id) => `courseId:"${id}"`)
              .join(" OR ");
            const caddieRequestsQuery = await caddieRequestsIndex.search(
              querySearch,
              {
                filters: `NOT status:"removed" AND (${courseIdsFilter})`,
              }
            );
            const caddieUids = caddieRequestsQuery.hits.map(
              (caddie) => caddie.caddieId
            );
            nearMeFilter = caddieUids.map((uid) => `uid:"${uid}"`).join(" OR ");
            // console.log(nearMeFilter);

            filters.push(`(${nearMeFilter})`);
          } else {
            setCaddieList([]); // ถ้าไม่มี course ใกล้เคียง
            setLoading(false);
            return;
          }
        }
        // ถ้ามีการค้นหาจาก province
        if (queryProvince) {
          const courseQuery = await courseIndex.search(queryProvince);
          const courseIds = courseQuery.hits.map((course) => course.id);

          if (courseIds.length > 0) {
            courseIdsFilter = courseIds
              .map((id) => `courseId:"${id}"`)
              .join(" OR ");
            const caddieRequestsQuery = await caddieRequestsIndex.search(
              querySearch,
              {
                filters: `NOT status:"removed" AND (${courseIdsFilter})`,
              }
            );

            const caddieUids = caddieRequestsQuery.hits.map(
              (caddie) => caddie.caddieId
            );
            if (caddieUids.length > 0) {
              caddieUidsFilter = caddieUids
                .map((uid) => `uid:"${uid}"`)
                .join(" OR ");
              filters.push(`(${caddieUidsFilter})`);
            } else {
              setCaddieList([]); // ถ้าไม่มี caddie ที่ตรงกับ province
              setLoading(false);
              return;
            }
          }
        }

        // ค้นหาตาม querySearch และ caddieRequests
        if (querySearch) {
          const [usersQuery, caddieRequestsQuery, caddieProfileQuery] =
            await Promise.all([
              usersIndex.search(querySearch, { filters: "role:caddie" }),
              caddieRequestsIndex.search(querySearch, {
                filters: 'NOT status:"removed"',
              }),
              caddieProfilesIndex.search(querySearch),
            ]);

          const userUids = usersQuery.hits.map((user) => user.uid);
          const caddieRequestUids = caddieRequestsQuery.hits.map(
            (caddie) => caddie.caddieId
          );
          const caddieProfileUids = caddieProfileQuery.hits.map(
            (caddie) => caddie.caddieId
          );
          // console.log(caddieRequestUids)
          // console.log(caddieProfileUids)
          const allUids = [
            ...new Set([
              ...userUids,
              ...caddieRequestUids,
              ...caddieProfileUids,
            ]),
          ];
          if (allUids.length > 0) {
            filters.push(
              `(${allUids.map((uid) => `uid:"${uid}"`).join(" OR ")})`
            );
          } else {
            setCaddieList([]); // ถ้าไม่มี caddie ที่ตรงกับ province
            setLoading(false);
            return;
          }
        }

        const usersResults = await usersIndex.search("", {
          filters: filters.join(" AND "),
          page,
          hitsPerPage: 20,
        });

        let users = usersResults.hits;
        // console.log(filters.join(" AND "));
        // console.log(users);
        if (users.length === 0) {
          setLoading(false);
          setHasMore(false);
          return;
        }

        const caddieUids = users.map((user) => user.uid);
        const caddieUidsQuery = caddieUids
          .map((uid) => `caddieId:"${uid}"`)
          .join(" OR ");

        const [caddieRequestsResults] = await Promise.all([
          caddieRequestsIndex.search("", { filters: `(${caddieUidsQuery})` }),
        ]);

        // const caddieProfiles = caddieProfilesResults.hits;
        // const courses = courseResults.hits;
        const caddieRequests = caddieRequestsResults.hits.filter(
          (req) => req.status !== "removed"
        );

        const validUsers = users.filter((user) =>
          caddieRequests.some((req) => req.caddieId === user.uid)
        );

        const combinedCaddies = validUsers.map((user) => {
          const caddieRequest =
            caddieRequests.find((req) => req.caddieId === user.uid) || {};

          return { ...user, caddieRequest };
        });
        // console.log(users);
        setCaddieList((prevState) =>
          page === 0 ? combinedCaddies : [...prevState, ...combinedCaddies]
        );
        setOriginalCaddieList((prevState) =>
          page === 0 ? combinedCaddies : [...prevState, ...combinedCaddies]
        );
        setHasMore(usersResults.hits.length > 0);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCaddies();
  }, [page, triggerSearch, search, sortData, userData, caddieId]);

  // เมื่อ page เปลี่ยน จะทำการเรียกใช้ useEffect ใหม่
  // ฟังก์ชันที่ตรวจจับเมื่อผู้ใช้เลื่อนถึงล่างสุดของหน้า
  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop ===
        document.documentElement.offsetHeight &&
      !loading &&
      hasMore
    ) {
      setPage((prevPage) => prevPage + 1); // เพิ่ม page เมื่อเลื่อนถึงล่างสุด
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll); // ติดตามการเลื่อนของหน้า
    return () => {
      window.removeEventListener("scroll", handleScroll); // ลบ event listener เมื่อ component ถูกลบ
    };
  }, [loading, hasMore]);

  const handleShow = async (docID) => {
    setFavoriteFriends(false);
    setShow(true);

    const docRef = doc(firestore, "users", docID);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      let isFriend = false;

      if (docSnap.data().uid) {
        const q3 = query(
          collection(firestore, "friends"),
          where("friendId", "==", docSnap.data().uid),
          where("userId", "==", userData?.uid)
        );

        const q2 = query(
          collection(firestore, "friends"),
          where("friendId", "==", userData?.uid),
          where("userId", "==", docSnap.data().uid)
        );

        const querySnapshot2 = await getDocs(q2);
        querySnapshot2.forEach(async (doc2) => {
          if (doc2.data().status == "active") {
            isFriend = true;
          }
        });

        const querySnapshot3 = await getDocs(q3);
        querySnapshot3.forEach(async (doc3) => {
          if (doc3.data().status == "active") {
            isFriend = true;
          }
        });
      }

      // const q_caddieAssignments = query(
      //   collection(firestore, "caddieAssignments"),
      //   where("caddieId", "==", docSnap.data().uid)
      // );
      const q_caddieAssignments = query(
        collection(firestore, "caddieRequests"),
        where("caddieId", "==", docSnap.data().uid)
      );
      const querySnapshot_caddieAssignments = await getDocs(
        q_caddieAssignments
      );
      querySnapshot_caddieAssignments.forEach(async (docCaddieAssignment) => {
        const docRefCourse = doc(
          firestore,
          "courses",
          docCaddieAssignment.data().courseId
        );
        const docSnapCourse = await getDoc(docRefCourse);

        if (docSnapCourse.exists()) {
          setCourseData({
            ...docSnapCourse.data(),
            courseId: docSnapCourse.id,
          });
        } else {
          console.log("No such document!");
        }
      });

      setCaddieData({ isFriend: isFriend, ...docSnap.data() });

      // const q_caddieProfiles = query(
      //   collection(firestore, "caddieProfiles"),
      //   where("caddieId", "==", docSnap.data().uid)
      // );
      // const querySnapshot_caddieProfiles = await getDocs(q_caddieProfiles);
      // querySnapshot_caddieProfiles.forEach(async (docCaddieprofile) => {
      //   let listImage = [
      //     { imageUrl: docSnap.data()?.profileImage, isPrimary: true, order: 0 },
      //   ];
      //   const querySnapshot = await getDocs(
      //     collection(firestore, "caddieProfiles", docCaddieprofile.id, "image")
      //   );
      //   querySnapshot.forEach((doc) => {
      //     listImage.push(doc.data());
      //   });
      //   setCaddieProfile({ ...docCaddieprofile.data(), image: listImage });
      // });

      const q_caddieProfiles = query(
        collection(firestore, "caddieProfiles"),
        where("caddieId", "==", docSnap.data().uid)
      );

      const querySnapshot_caddieProfiles = await getDocs(q_caddieProfiles);

      if (!querySnapshot_caddieProfiles.empty) {
        querySnapshot_caddieProfiles.forEach(async (docCaddieProfile) => {
          let listImage = [
            {
              imageUrl: docSnap.data()?.profileImage,
              isPrimary: true,
              order: 0,
            },
          ];

          const querySnapshot = await getDocs(
            collection(
              firestore,
              "caddieProfiles",
              docCaddieProfile.id,
              "image"
            )
          );

          querySnapshot.forEach((doc) => {
            listImage.push(doc.data());
          });

          setCaddieProfile({ ...docCaddieProfile.data(), image: listImage });
        });
      } else {
        // ถ้าไม่มีข้อมูลใน caddieProfiles ใช้ profileImage จาก docSnap โดยตรง
        const listImage = [
          { imageUrl: docSnap.data()?.profileImage, isPrimary: true, order: 0 },
        ];
        setCaddieProfile({ ...docSnap.data(), image: listImage });
      }
    }

    if (docSnap.data().uid === undefined) {
    } else {
      const q = query(
        collection(firestore, "favoriteFriends"),
        where("caddieId", "==", docSnap.data().uid),
        where("userId", "==", userData.uid)
      );
      const querySnapshot = await getDocs(q);
      if (querySnapshot.size == 0) {
        setFavoriteFriends(false);
      } else {
        querySnapshot.forEach((doc1) => {
          if (doc1.data().status == "active") {
            setFavoriteFriends(true);
          } else {
            setFavoriteFriends(false);
          }
        });
      }
    }
  };

  useEffect(() => {
    const fav = [];

    async function getFavUserCaddie() {
      const caddieQuery = query(
        collection(firestore, "favoriteFriends"),
        where("userId", "==", userData.uid),
        where("status", "==", "active")
      );

      const querySnapshot = await getDocs(caddieQuery);

      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          fav.push(doc.data().caddieId);
        });
      }
    }

    async function getFavUser() {
      const playerQuery = query(
        collection(firestore, "favoritePlayers"),
        where("userId", "==", userData.uid),
        where("status", "==", "active")
      );

      const querySnapshot = await getDocs(playerQuery);

      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          fav.push(doc.data().playerId);
        });
      }
    }

    if (userData) {
      getFavUserCaddie();
      getFavUser();

      setFavoriteFriendsList(fav);
    }
  }, [userData]);

  const handleFav = async (isCaddie, friendId, favType) => {
    if (userData && friendId) {
      if (favType === "fav") {
        if (isCaddie === "caddie") {
          setFavoriteFriendsList((prev) => [...prev, friendId]);
          const isFav = await favFriendCaddie(userData?.uid, friendId);
        } else {
          setFavoriteFriendsList((prev) => [...prev, friendId]);
          const isFav = await favFriend(userData?.uid, friendId);
        }
      } else {
        if (isCaddie === "caddie") {
          setFavoriteFriendsList((prev) =>
            prev.filter((id) => id !== friendId)
          );
          const isUnFav = await favFriendCaddie(userData?.uid, friendId);
        } else {
          setFavoriteFriendsList((prev) =>
            prev.filter((id) => id !== friendId)
          );
          const isUnFav = await favFriend(userData?.uid, friendId);
        }
      }
    }
  };

  const handleProfileClick = (uid) => {
    if (!uid) return;

    if (uid === userData.uid) {
      navigate("/userPage");
    } else {
      navigate("/user", { state: { uid: uid } });
    }
  };

  const handleChat = async (dooNineId) => {
    const result = await ChatTo(userData.dooNineId, dooNineId);
    if (result) {
      navigate("/chat-room?channelId=" + result[0].channel_url);
    }

    // try {
    //   const response = await axios.get(
    //     `https://api-DC03AD4D-419B-41A2-8305-AA8A4B972CA5.sendbird.com/v3/group_channels?members_exactly_in=${userData.dooNineId}&show_member=false&members_exactly_in=${dooNineId}`,
    //     {
    //       headers: {
    //         "Content-Type": "application/json; charset=utf8",
    //         "Api-Token": sendBird_api_token,
    //       },
    //     }
    //   );

    //   if (response.data.channels.length > 0) {
    //     isMobile
    //       ? navigate("/chat-room", {
    //           state: {
    //             channelUrl: response.data.channels[0].channel_url,
    //             previousPage: "caddie",
    //           },
    //         })
    //       : navigate("/chat", {
    //           state: {
    //             channelUrl: response.data.channels[0].channel_url,
    //             previousPage: "caddie",
    //           },
    //         });
    //   } else {
    //     const response2 = await axios.post(
    //       "https://api-DC03AD4D-419B-41A2-8305-AA8A4B972CA5.sendbird.com/v3/group_channels",
    //       {
    //         user_ids: [userData.dooNineId, dooNineId],
    //       },
    //       {
    //         headers: {
    //           "Content-Type": "application/json; charset=utf8",
    //           "Api-Token": sendBird_api_token,
    //         },
    //       }
    //     );
    //     isMobile
    //       ? navigate("/chat-room", {
    //           state: {
    //             channelUrl: response.data.channels[0].channel_url,
    //             previousPage: "caddie",
    //           },
    //         })
    //       : navigate("/chat", {
    //           state: {
    //             channelUrl: response.data.channels[0].channel_url,
    //             previousPage: "caddie",
    //           },
    //         });
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  };

  const handleSwitchChange = (checked, switchId) => {
    setTempSortData((prevState) => ({
      ...prevState,
      [switchId]: { ...prevState[switchId], state: checked },
    }));
  };

  const handleSubmit = () => {
    setSortData(tempSortData);
    handleCloseSortAndFilter();
  };

  const [showSortAndFilter, setShowSortAndFilter] = useState(false);
  const handleCloseSortAndFilter = () => {
    setTempSortData(sortData);
    setShowSortAndFilter(false);
  };
  const handleShowSortAndFilter = () => {
    setTempSortData(sortData);

    setShowSortAndFilter(true);
  };

  const handleInputChange = (e, field, type) => {
    const value = e && e.target ? e.target.value : e;

    setTempSortData((prevState) => ({
      ...prevState,
      [field]: { ...prevState[field], [type]: value },
    }));
  };

  return (
    <>
      <div className="card d-block border-0 rounded-3 overflow-hidden p-3 shadow-xss">
        <div className="d-flex w-100 flex-column flex-md-row p-2">
          <div className="d-inline-flex align-items-center gap-2 ms-auto align-items-stretch">
            <div className="flex-grow-1">
              <CaddieSearch
                search={search}
                setSearch={setSearch}
                openSearch={openSearch}
                setOpenSearch={setOpenSearch}
                setTriggerSearch={setTriggerSearch}
                setPage={setPage}
                setHasMore={setHasMore}
                searchInput={searchInput}
                setSearchInput={setSearchInput}
              ></CaddieSearch>
            </div>
            <button
              className="btn btn-light"
              onClick={() => handleShowSortAndFilter()}
            >
              <i className="feather-filter font-xss text-grey-500"></i>
            </button>
          </div>
        </div>

        <StackFilter
          trueStates={trueStates}
          sortData={sortData}
          setSortData={setSortData}
          setTempSortData={setTempSortData}
          search={search}
          setSearch={setSearch}
          originalCaddieList={originalCaddieList}
          setTriggerSearch={setTriggerSearch}
          setHasMore={setHasMore}
          setPage={setPage}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
        ></StackFilter>

        <div className="row gx-1 ps-1 pe-1">
          {caddieList.length > 0 ? (
            caddieList.map((value, index) => (
              <>
                <CaddieCard
                  key={value.id || index}
                  value={value}
                  index={index}
                  handleShow={handleShow}
                  handleChat={handleChat}
                  favoriteFriendsList={favoriteFriendsList}
                  handleFav={handleFav}
                  setSelectedUserLabel={setSelectedUserLabel}
                  setShowLabelModal={setShowLabelModal}
                ></CaddieCard>

                <ModalCaddieDetail
                  show={show}
                  setShow={setShow}
                  caddieData={caddieData}
                  setCaddieData={setCaddieData}
                  setCourseData={setCourseData}
                  setFavoriteFriends={setFavoriteFriends}
                  favoriteFriends={favoriteFriends}
                  caddieProfile={caddieProfile}
                  setCaddieProfile={setCaddieProfile}
                ></ModalCaddieDetail>
              </>
            ))
          ) : !loading ? (
            <h5 className="text-center p-2">No caddie available</h5>
          ) : null}
          {loading && (
            <div className="d-flex justify-content-center">
              <Load />
            </div>
          )}
        </div>
      </div>

      <ModalFilter
        showSortAndFilter={showSortAndFilter}
        setShowSortAndFilter={setShowSortAndFilter}
        handleCloseSortAndFilter={handleCloseSortAndFilter}
        tempSortData={tempSortData}
        handleSubmit={handleSubmit}
        handleSwitchChange={handleSwitchChange}
        handleInputChange={handleInputChange}
        userLabels={userLabels}
      />

      <Label
        triggerFriendList={triggerFriendList}
        setTriggerFriendList={setTriggerFriendList}
        showLabelModal={showLabelModal}
        setShowLabelModal={setShowLabelModal}
        setSelectedUserLabel={setSelectedUserLabel}
        selectedUserLabel={selectedUserLabel}
        userLabels={userLabels}
        triggerGetLabel={triggerGetLabel}
        setTriggerGetLabel={setTriggerGetLabel}
      />
    </>
  );
}

export default CourseDetailCaddieBody;

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}
